import React from 'react';

const Tercero = () => {
    return (
        <div className='seccion'>

            <h1>PROGRAMAS DE ESTUDIOS - 2023</h1>

            <h4>Materias Plan Institucional - 3er y 4to año</h4>

            <div className="contenedor-tablas">

			<table className="tabla-programas">
            
                <caption>3er Año</caption>
				<tr>

					<th>Materia</th>
					<th>Programa</th>

				</tr>
				
				<tr>

					<td>Adm. Empresas</td>
					<td><a href="https://drive.google.com/drive/folders/1ZB6oGTykpbamN-o-QIo7fiXp0YhCG_MT?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Contabilidad</td>
					<td><a href="https://drive.google.com/drive/folders/1FvoOidv0XXemupHahGHCuFyvhx3J-ge2?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Derecho</td>
					<td><a href="https://drive.google.com/drive/folders/1JZD1SLQKPysBvuOR9ZRiOsV3aSBDBClh?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Economia</td>
					<td><a href="https://drive.google.com/drive/folders/1ao0fO8s_2JisAgCnR7RCTjbbsVN-bC4t?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ed. Civica</td>
					<td><a href="https://drive.google.com/drive/folders/1rUUlDRgjts6f3omviKwW7MxXY_G1ZW_M?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Fisica</td>
					<td><a href="https://drive.google.com/drive/folders/11VO9H-6mOgwMaHEolfEVlXxOemrmGAM4?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Ingles</td>
					<td><a href="https://drive.google.com/drive/folders/1Ds-35yhEkc43T6yvH_CMfPUKe_Yz4roC?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Lengua</td>
					<td><a href="https://drive.google.com/drive/folders/1MnnRuie63KBBmCY6nCdjIYkYrUGG_-dN?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Matematica</td>
					<td><a href="https://drive.google.com/drive/folders/1P1hn0EiTHlXQF1GRRNwbx_yDajFqAfOu?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>
				
				<tr>

					<td>Psicologia</td>
					<td><a href="https://drive.google.com/drive/folders/1M5UAGKijDYM0HgIHgyYRUgKcR2gDST3K?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

				</tr>

			</table>

			<table className="tabla-programas">
				<caption>4to Año</caption>
				<tr>

					<th>Materia</th>
					<th>Programa</th>

				</tr>
			
			<tr>

				<td>Ap. y Pllab</td>
				<td><a href="https://drive.google.com/drive/folders/1YEOakAR8w6iAKeHwUdAOMZ7o3-X5EJmZ?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Contabilidad</td>
				<td><a href="https://drive.google.com/drive/folders/1Yri6P82NgqvyXq9o9Oe3p_EKM_9JucyM?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Derecho</td>
				<td><a href="https://drive.google.com/drive/folders/1Z2cJSe5fw42ceBDoM9wkjLG1RaBtqulr?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Finanzas</td>
				<td><a href="https://drive.google.com/drive/folders/16VM2bpW4lrqxSwuAAlCZ9R9G5bNZBYUx?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Ingles</td>
				<td><a href="https://drive.google.com/drive/folders/1rEfaq90TtNli5uFYGUHSqLD1uTUSA6JZ?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Leg. y Prac. de Campo</td>
				<td><a href="https://drive.google.com/drive/folders/15zrvg25Ri2_0mfXHMLmfv2ha-fsn1CB3?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Lengua</td>
				<td><a href="https://drive.google.com/drive/folders/1kpRjvjm4-nlBpmNH04arAQON3ohXXLKc?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Matematica</td>
				<td><a href="https://drive.google.com/drive/folders/1us7ImVrJrdTDlgwn816bm79d4xNOFLjK?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

			</tr>
			
			<tr>

				<td>Quimica</td>
				<td><a href="https://drive.google.com/drive/folders/1DuWUfftY8DP8uOYOUJdBdMDuHGOS_Cug?usp=drive_link" target="_blank" class="links" ><button>Click Aca</button></a></td>

			</tr>
				
			</table>		
		
			</div>            
           


		</div>
    );
}

export default Tercero;
